import * as React from 'react';

const TreeContext = React.createContext({});

export { TreeContext };
